import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  boxOuter: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer'
  },
  boxInner: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: ({ isLast }) => (isLast ? '' : '1px solid'),
    '&:hover *': {
      color: theme.palette.secondary.main
    }
  }
});

const Suggestion = ({ description, isLast, classes, dataTestId, ...props }) => {
  const { placeId, active, matchedSubstrings, ...suggestionProps } = props;
  return (
    <Box
      {...suggestionProps}
      className={classes.boxOuter}
      component={ListItem}
      width="100%"
      data-testid={dataTestId}
    >
      <Box
        color="borders.primary"
        component="span"
        display="block"
        width="100%"
        isLast
        className={classes.boxInner}
      >
        <Typography>{description}</Typography>
      </Box>
    </Box>
  );
};

Suggestion.defaultProps = {
  isLast: false,
  dataTestId: 'autocomplete-suggestion'
};

Suggestion.propTypes = {
  description: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    boxOuter: PropTypes.string,
    boxInner: PropTypes.string
  }),
  dataTestId: PropTypes.string,
  placeId: PropTypes.any,
  active: PropTypes.any,
  matchedSubstrings: PropTypes.any,
  isLast: PropTypes.bool
};

export default withStyles(styles)(Suggestion);
